export const environment = {
  production: true,
  baseUrl: 'https://lfpsc4ch.www.printos.com' ,
  agmkey: 'AGMKEY',
  ga_code: 'UA-69196706-1',
  redirectURL: 'https://www.printos.com',
  redirectTo_CN_URL: 'https://www.printos.cn',
  maintainanceURL: 'https://hpgraphicspartners.www.printos.com',
  showWhiteList: false,
  gtag_code : '',
  hotjarId : 3405278
};
